module.exports = __webpack_public_path__ + "static/media/2016.196de119.svg";